// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--oss7_","text":"_4f720283bf--text--jY6XN"};